import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { AbstractControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';

import {
  CommonReportDictionaryItem,
  LatestCasesChangePayload,
  ReportFilterChange,
  ReportFiltersParams
} from '../../models/report-filters.model';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

export const latestCasesShowAllValue = '4';

@Component({
  selector: 'stx-latest-cases-filter',
  templateUrl: './latest-cases-filter.component.html',
  styleUrls: ['./latest-cases-filter.component.scss'],
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton, NgClass, TranslateModule]
})
export class LatestCasesFilterComponent extends BaseComponent implements OnInit {
  private route = inject(ActivatedRoute);

  private static readonly DEFAULT_VALUE = '3';
  @Input() latestCasesOptions: CommonReportDictionaryItem[];
  @Input() formGroupReference: UntypedFormGroup;
  @Input() controlName: string;
  @Output() filterChange = new EventEmitter<ReportFilterChange<LatestCasesChangePayload>>();

  private latestCasesInitialParam: string;
  private control: AbstractControl;

  ngOnInit(): void {
    this.control = this.formGroupReference.get(this.controlName);
    this.watchQueryParamsChange();
    this.watchFilterChanges();
    this.setDefaultValue();
  }

  private emitFilterModel(value: string): void {
    this.filterChange.emit({
      filterName: 'latestCases',
      payload: {
        latestCases: [value]
      }
    });
  }

  private setDefaultValue() {
    if (this.latestCasesInitialParam) {
      this.setValueFromParams();
    } else {
      this.control.setValue(LatestCasesFilterComponent.DEFAULT_VALUE);
    }
  }

  private watchFilterChanges() {
    this.subSink.sink = this.control.valueChanges.subscribe(this.emitFilterModel.bind(this));
  }

  private watchQueryParamsChange() {
    this.subSink.sink = this.route.queryParams
      .pipe(filter((params: ReportFiltersParams) => !!params.latestCases))
      .subscribe((params: ReportFiltersParams) => {
        this.latestCasesInitialParam = params.latestCases;

        this.setValueFromParams();
      });
  }

  setValueFromParams() {
    this.control.setValue(this.latestCasesInitialParam);
  }
}
